import { ModelListData } from "../../../shared/utils/interfaces/ModelResponse";

export const filterUnVariantModels = (models: ModelListData[]): ModelListData[] => {
    return models.filter(model => model.variants.length > 0);
}